import ReactDOM from 'react-dom/client'
import './i18n/i18n.ts'
import { Provider } from 'react-redux'
import { store } from './store'
import Language from './utils/hooks/Language.js'
import { createTheme, MantineProvider } from '@mantine/core'
import 'dayjs/locale/es'
import { DatesProvider } from '@mantine/dates'
import App from './components/App'
import { theme } from './theme/theme.ts'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}
const root = ReactDOM.createRoot(rootElement)
root.render(
  <Language>
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <DatesProvider
          settings={{ locale: 'es', firstDayOfWeek: 1, weekendDays: [0, 6] }}
        >
          <App />
        </DatesProvider>
      </MantineProvider>
    </Provider>
  </Language>,
)
